import { render, staticRenderFns } from "./StrategyFixPage.vue?vue&type=template&id=30755f96"
import script from "./StrategyFixPage.vue?vue&type=script&lang=ts"
export * from "./StrategyFixPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports